<template>
  <div id="app">
     <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  components: {
  }
}
</script>
<style>
   /* #app{
    height: 100%;
      overflow: auto;
      -webkit-overflow-scrolling: touch;
    }  */
</style>




// WEBPACK FOOTER //
// src/App.vue